<template>
  <article class="flex flex-col gap-2 rounded-md border border-slate-200 bg-slate-50 p-3">
    <header class="flex items-center justify-between gap-3 p-1">
      <div class="text-xs">
        <span v-if="note.user?.name">{{ note.user.name }}</span>
        <span v-else>System</span> at:
        <span class="text-slate-500">{{ createdAtLabel }}</span>
      </div>
      <div v-if="!readonly" class="flex flex-row items-end gap-2">
        <button
          class="rounded-md border border-slate-300 px-2 py-1 text-xs font-medium text-slate-700 transition hover:bg-slate-100 disabled:cursor-not-allowed disabled:opacity-60"
          type="button"
          :disabled="deleting"
          @click="$emit('reply', note)"
        >
          {{ replyLabel }}
        </button>
        <button
          class="rounded-md border border-red-300 px-2 py-1 text-xs font-medium text-red-700 transition hover:bg-red-50 disabled:cursor-not-allowed disabled:opacity-60"
          type="button"
          :disabled="deleting"
          @click="$emit('delete', note)"
        >
          {{ deleting ? deletingLabel : deleteLabel }}
        </button>
      </div>
    </header>

    <blockquote v-if="quotedNote" class="rounded-md border-l-4 border-slate-300 bg-slate-100 px-3 py-2 text-xs text-slate-600">
      {{ quotedNote.contents }}
    </blockquote>

    <p class="whitespace-pre-wrap text-sm text-slate-700 py-2">
      {{ note.contents }}
    </p>

    <div v-if="noteUploads.length > 0" class="flex flex-wrap items-center gap-2">
      <UploadedFile v-for="uploadedFile in noteUploads" :key="uploadedFile.id" :file="uploadedFile" :deletable="false" />
    </div>

    <footer class="text-xs text-slate-500 gap-1 flex justify-between" />
  </article>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import UploadedFile from '../../../../../uploadable/resources/js/components/UploadedFile.vue'

const props = defineProps({
  note: {
    type: Object,
    required: true,
  },
  deleting: {
    type: Boolean,
    default: false,
  },
  readonly: {
    type: Boolean,
    default: false,
  },
})

defineEmits(['reply', 'delete'])

const { t } = useI18n()

const replyLabel = computed(() => t('notes.card.replyButton'))
const deleteLabel = computed(() => t('notes.card.deleteButton'))
const deletingLabel = computed(() => t('notes.card.deletingButton'))
const quotedNote = computed(() => props.note.reply_to_note ?? props.note.replyToNote ?? null)
const noteUploads = computed(() => {
  if (!Array.isArray(props.note.uploads)) {
    return []
  }

  return props.note.uploads
})

const createdAtLabel = computed(() => {
  if (!props.note.created_at) {
    return ''
  }

  const date = new Date(props.note.created_at)
  if (Number.isNaN(date.getTime())) {
    return ''
  }

  return date.toLocaleString()
})
</script>
